export type LogTimestampParts = {
  date: string;
  time: string;
};

function toValidDate(value: string | null | undefined): Date | null {
  if (!value) {
    return null;
  }

  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function formatLogTimestamp(
  value: string | null | undefined,
  locale?: string,
): string {
  const date = toValidDate(value);
  if (!date) {
    return '-';
  }

  return new Intl.DateTimeFormat(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  }).format(date);
}

export function formatLogTimestampParts(
  value: string | null | undefined,
  locale?: string,
): LogTimestampParts | null {
  const date = toValidDate(value);
  if (!date) {
    return null;
  }

  return {
    date: new Intl.DateTimeFormat(locale, {
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    }).format(date),
    time: new Intl.DateTimeFormat(locale, {
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    }).format(date),
  };
}
